import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FundraiserSliderImgComponent } from './fundraiser-slider-img.component';
import { KettoAssuredModule } from '../ketto-assured/ketto-assured.module';
import { NgxGlideModule } from 'ngx-glide';
import { SocialShareModule } from '../social-share/social-share.module';



@NgModule({
  declarations: [
    FundraiserSliderImgComponent
  ],
  imports: [
    CommonModule,
    KettoAssuredModule,
    NgxGlideModule,
    SocialShareModule
  ],
  bootstrap: [FundraiserSliderImgComponent],
  exports: [FundraiserSliderImgComponent]
})
export class FundraiserSliderImgModule { }
